import AuthService from '../services/AuthService';
import history from '../services/history';

export default function createMenu() {
  const usuario = AuthService.getUsuario();
  const { idUsuarioPerfil } = usuario;

  const menuReturn = [
    {
      label: 'Home',
      title: 'Home',
      icon: 'pi pi-fw pi-home',
      to: '/home',
    },
  ];

  let menuCadastros = { items: [] };
  const menuCadastroPessoal = {
    label: 'Pessoal',
    title: 'Pessoal',
    icon: 'pi pi-fw pi-users',
    items: [],
  };

  const menuCadastroOutros = {
    label: 'Outros',
    title: 'Outros',
    icon: 'pi pi-fw pi-clone',
    items: [],
  };
  const menuCadastroProdutos = {
    label: 'Produto',
    title: 'Produtos',
    icon: 'pi pi-fw pi-briefcase',
    items: [],
  };

  let menuDashboard;
  if (AuthService.checkRoles(['DASHBOARD_ACESSAR'])) {
    menuDashboard = {
      label: 'Dashboard',
      title: 'Dashboard',
      icon: 'pi pi-fw pi-chart-bar',
      to: '/dashboard',
    };
  }

  let menuLancamentos = { items: [] };
  // let menuRelatorios = { items: [] };
  let menuUtilitarios = { items: [] };

  if (idUsuarioPerfil === !1) {
    menuCadastros = null;
  } else {
    menuLancamentos = {
      title: 'Lançamentos',
      label: 'Lançamentos',
      icon: 'pi pi-fw pi-list',
      expanded: true,
      items: [],
    };

    menuCadastros = {
      title: 'Cadastros',
      label: 'Cadastros',
      icon: 'pi pi-fw pi-folder',
      expanded: true,
      items: [],
    };

    menuUtilitarios = {
      title: 'Utilitários',
      label: 'Utilitários',
      icon: 'pi pi-fw pi-cog',
      expanded: true,
      items: [],
    };

    // menu cadastros
    if (
      AuthService.checkRoles(['USUARIO_ACESSAR', 'USUARIO_INSERIR', 'USUARIO_ALTERAR']) &&
      AuthService.isPerfilGerente()
    ) {
      menuCadastroPessoal.items.push({
        title: 'Usuário',
        label: 'Usuário',
        icon: 'pi pi-user',

        command: () => history.push('/usuarios'),
      });
    }

    if (
      AuthService.checkRoles([
        'COLABORADOR_ACESSAR',
        'COLABORADOR_INSERIR',
        'COLABORADOR_ALTERAR',
      ])
    ) {
      menuCadastroPessoal.items.push({
        title: 'Colaborador',
        label: 'Colaborador',
        icon: 'far fa-user-circle',

        command: () => history.push('/colaboradores'),
      });
    }

    if (
      AuthService.checkRoles([
        'COLABORADOR_ACESSAR',
        'COLABORADOR_INSERIR',
        'COLABORADOR_ALTERAR',
      ])
    ) {
      menuCadastroPessoal.items.push({
        title: 'Cliente',
        label: 'Cliente',
        icon: 'far fa-user',

        command: () => history.push('/clientes'),
      });
    }

    if (
      AuthService.checkRoles(['REVENDA_ACESSAR', 'REVENDA_INSERIR', 'REVENDA_ALTERAR']) &&
      AuthService.isPerfilGerente()
    ) {
      menuCadastroPessoal.items.push({
        title: 'Revenda',
        label: 'Revenda',
        icon: 'pi pi-sitemap',

        command: () => history.push('/revendas'),
      });
    }

    if (
      AuthService.checkRoles([
        'CHAMADO_TIPO_ACESSAR',
        'CHAMADO_TIPO_INSERIR',
        'CHAMADO_TIPO_ALTERAR',
      ]) &&
      AuthService.isPerfilGerente()
    ) {
      menuCadastroOutros.items.push({
        title: 'Tipo de Chamado',
        label: 'Tipo de Chamado',
        icon: 'far fa-list-alt',

        command: () => history.push('/chamadosTipo'),
      });
    }

    if (
      AuthService.checkRoles([
        'ATEND_TOPICO_CLASSIFICADOR_ACESSAR',
        'ATEND_TOPICO_CLASSIFICADOR_INSERIR',
        'ATEND_TOPICO_CLASSIFICADOR_ALTERAR',
      ]) &&
      AuthService.isPerfilGerente()
    ) {
      menuCadastroOutros.items.push({
        title: 'Tópico Atendimento',
        label: 'Tópico Atendimento',
        icon: 'pi pi-sitemap',

        command: () => history.push('/atendimentoTopicos'),
      });
    }

    if (
      AuthService.checkRoles([
        'CATEGORIA_ARQUIVO_ACESSAR',
        'CATEGORIA_ARQUIVO_INSERIR',
        'CATEGORIA_ARQUIVO_ALTERAR',
      ]) &&
      AuthService.isPerfilGerente()
    ) {
      menuCadastroOutros.items.push({
        title: 'Categoria de Arquivos',
        label: 'Categoria de Arquivos',
        icon: 'pi pi-sitemap',

        command: () => history.push('/arquivoCategorias'),
      });
    }

    if (
      AuthService.checkRoles([
        'SUBCATEGORIA_ARQUIVO_ACESSAR',
        'SUBCATEGORIA_ARQUIVO_INSERIR',
        'SUBCATEGORIA_ARQUIVO_ALTERAR',
      ]) &&
      AuthService.isPerfilGerente()
    ) {
      menuCadastroOutros.items.push({
        title: 'Subcategoria de Arq.',
        label: 'Subcategoria de Arq.',
        icon: 'pi pi-bars',

        command: () => history.push('/arquivoSubcategorias'),
      });
    }

    if (
      AuthService.checkRoles([
        'ATEND_CLASSIFICACAO_ACESSAR',
        'ATEND_CLASSIFICACAO_INSERIR',
        'ATEND_CLASSIFICACAO_ALTERAR',
      ]) &&
      AuthService.isPerfilGerente()
    ) {
      menuCadastroOutros.items.push({
        title: 'Classificação Atend.',
        label: 'Classificação Atend.',
        icon: 'pi pi-bars',

        command: () => history.push('/atendimentoClassificacoes'),
      });
    }

    if (
      AuthService.checkRoles(['MODULO_ACESSAR', 'MODULO_INSERIR', 'MODULO_ALTERAR']) &&
      AuthService.isPerfilGerente()
    ) {
      menuCadastroOutros.items.push({
        title: 'Módulo',
        label: 'Módulo',
        icon: 'pi pi-sliders-h',

        command: () => history.push('/modulos'),
      });
    }

    if (
      AuthService.checkRoles(['SISTEMA_ACESSAR', 'SISTEMA_INSERIR', 'SISTEMA_ALTERAR']) &&
      AuthService.isPerfilGerente()
    ) {
      menuCadastroOutros.items.push({
        title: 'Sistema',
        label: 'Sistema',
        icon: 'pi pi-sliders-v',

        command: () => history.push('/sistemas'),
      });
    }

    if (
      AuthService.checkRoles(['CAMPANHA_ACESSAR', 'CAMPANHA_INSERIR', 'CAMPANHA_ALTERAR']) &&
      AuthService.isPerfilGerente()
    ) {
      menuCadastroOutros.items.push({
        title: 'Campanha de Venda',
        label: 'Campanha de Venda',
        icon: 'pi pi-briefcase',

        command: () => history.push('/campanhas'),
      });
    }

    if (
      AuthService.checkRoles([
        'FAMILIA_GRUPO_ACESSAR',
        'FAMILIA_GRUPO_INSERIR',
        'FAMILIA_GRUPO_ALTERAR',
      ])
    ) {
      menuCadastroProdutos.items.push({
        title: 'Grupo de Família',
        label: 'Grupo de Família',
        icon: 'far fa-object-ungroup',

        command: () => history.push('/familiaGrupos'),
      });
    }

    if (AuthService.checkRoles(['FAMILIA_ACESSAR', 'FAMILIA_INSERIR', 'FAMILIA_ALTERAR'])) {
      menuCadastroProdutos.items.push({
        title: 'Família',
        label: 'Família',
        icon: 'pi pi-desktop',

        command: () => history.push('/familias'),
      });
    }

    if (AuthService.checkRoles(['PRODUTO_ACESSAR', 'PRODUTO_INSERIR', 'PRODUTO_ALTERAR'])) {
      menuCadastroProdutos.items.push({
        title: 'Produtos',
        label: 'Produtos',
        icon: 'pi pi-credit-card',

        command: () => history.push('/produtos'),
      });
    }

    if (AuthService.checkRoles(['USUARIO_PERFIL_ACESSAR'])) {
      menuCadastroOutros.items.push({
        title: 'Perfil de Acesso',
        label: 'Perfil de Acesso',
        icon: 'pi pi-key',
        command: () => history.push('/usuarioPerfis'),
      });
    }

    // menu Lançamentos
    // menuLancamentos.items.push({
    //   title: 'Agenda',
    //   label: 'Agenda',
    //   icon: 'pi pi-calendar',
    //   command: () => history.push('/agendas'),
    // });
    menuLancamentos.items.push({
      title: 'Chamado',
      label: 'Chamado',
      icon: 'far fa-newspaper',
      command: () => history.push('/chamados'),
    });
    if (
      AuthService.checkRoles(['ORCAMENTO_ACESSAR', 'ORCAMENTO_INSERIR', 'ORCAMENTO_ALTERAR'])
    ) {
      menuLancamentos.items.push({
        title: 'Orçamento',
        label: 'Orçamento',
        icon: 'pi pi-th-large',
        command: () => history.push('/orcamentos'),
      });
    }

    menuLancamentos.items.push({
      title: 'Desenvolvimento',
      label: 'Desenvolvimento',
      icon: 'pi pi-book',
      command: () => history.push('/desenvolvimentos'),
    });

    menuLancamentos.items.push({
      title: 'Acompanhamento Vendas',
      label: 'Acompanhamento Vendas',
      icon: 'pi pi-table',
      command: () => history.push('/acompanhamentoVendas'),
    });

    if (
      AuthService.checkRoles([
        'VERSAO_SISTEMA_ACESSAR',
        'VERSAO_SISTEMA_INSERIR',
        'VERSAO_SISTEMA_ALTERAR',
      ]) &&
      AuthService.isPerfilGerente()
    ) {
      menuLancamentos.items.push({
        title: 'Versões dos Sistemas',
        label: 'Versões dos Sistemas',
        icon: 'pi pi-align-center',

        command: () => history.push('/versaoSistemas'),
      });
    }

    // distribuicao fisica das versoes (pacotes + liberacoes + telemetria) —
    // irma da tela acima: la o ANUNCIO, aqui o PACOTE que os clientes baixam
    if (AuthService.checkRoles(['ATUALIZACAO_ACESSAR']) && AuthService.isPerfilGerente()) {
      menuLancamentos.items.push({
        title: 'Atualizações (Distribuição)',
        label: 'Atualizações (Distribuição)',
        icon: 'pi pi-cloud-upload',
        command: () => history.push('/atualizacoes'),
      });
    }

    // licenciamento por assento dos sistemas 10.9+ (os legados seguem nas telas de chave).
    // So pela permissao (como a Chave Liberacao): quem ve e decidido no perfil, no banco.
    if (AuthService.checkRoles(['LICENCA_ACESSAR'])) {
      menuLancamentos.items.push({
        title: 'Licenças (10.9+)',
        label: 'Licenças (10.9+)',
        icon: 'pi pi-key',
        command: () => history.push('/licencas'),
      });
    }

    if (
      AuthService.checkRoles([
        'GERENCIADOR_ARQUIVO_ACESSAR',
        'GERENCIADOR_ARQUIVO_INSERIR',
        'GERENCIADOR_ARQUIVO_ALTERAR',
      ]) &&
      AuthService.isPerfilGerente()
    ) {
      menuLancamentos.items.push({
        title: 'Gerenciador de Arquivos',
        label: 'Gerenciador de Arquivos',
        icon: 'pi pi-sliders-h',

        command: () => history.push('/gerenciadorArquivos'),
      });
    }
  }

  if (menuCadastroPessoal.items.length > 0) {
    menuCadastros.items.push(menuCadastroPessoal);
  }

  // if (menuCadastroProdutos.items.length > 0) {
  //   menuCadastros.items.push(menuCadastroProdutos);
  // }

  if (menuCadastroOutros.items.length > 0) {
    menuCadastros.items.push(menuCadastroOutros);
  }

  if (menuDashboard) {
    menuReturn.push(menuDashboard);
  }

  if (menuCadastros && menuCadastros.items.length > 0) {
    menuReturn.push(menuCadastros);
  }

  if (menuLancamentos) {
    menuReturn.push(menuLancamentos);
  }

  // if (menuRelatorios) {
  //   menuReturn.push(menuRelatorios);
  // }

  if (menuUtilitarios && menuUtilitarios.items.length > 0) {
    menuReturn.push(menuUtilitarios);
  }

  menuReturn.push({
    label: 'Boletos',
    title: 'Boletos',
    icon: 'pi pi-align-justify',
    to: '/boletos',
  });

  menuReturn.push({
    label: 'Chave Liberação',
    title: 'Chave Liberação',
    icon: 'pi pi-unlock',
    to: '/chaves',
  });

  menuReturn.push({
    label: 'Backup Cliente',
    title: 'Backup Cliente',
    icon: 'pi pi-cloud',
    to: '/clientesBackup',
  });

  menuReturn.push({
    title: 'Senha do Gerencial',
    label: 'Senha do Gerencial',
    icon: 'pi pi-key',
    command: () => history.push('/senhaGerencial'),
  });

  if (AuthService.checkRoles(['AUDITORIA_ACESSAR'])) {
    menuReturn.push({
      title: 'Auditoria',
      label: 'Auditoria',
      icon: 'pi pi-bars',
      command: () => history.push('/auditoria'),
    });
  }

  return menuReturn;
}
